import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    paginationWrapper: {
        display: 'flex',
        margin: theme.spacing(3, 0),
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-end',
        },
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
        }
    },
    title: {
        width: '100%',
        height: 'auto',
        padding: '0 7.5%',
        margin: '1% 0',
        [theme.breakpoints.down('769')]: {
            width: '90%',
        },
    },
    subtitle: {
        borderLeftColor: '#F5B750',
        borderLeftStyle: 'solid',
        borderLeftWidth: 7,
        fontSize: 26,
        color: '#344450',
        fontWeight: 'bold',
        padding: '2% 3%',
        margin: '1% 0',
        [theme.breakpoints.down('1100')]: {
            borderLeftWidth: 5,
            fontSize: 24,
        },
        [theme.breakpoints.down('769')]: {
            borderLeftWidth: 3,
            fontSize: 20,
        }
    },
    tab: {
        display: 'flex',
        width: '85%',
        margin: '0 auto',
        color: '#344450',
        backgroundColor: '#E4E4E4',
        [theme.breakpoints.down('769')]: {
            width: '100%'
        }
    },
    item: {
        width: 'auto',
        padding: '15px 0',
        cursor: 'pointer',
        textAlign: 'center',
        minWidth: `${100 / 3}%`,
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
            padding: '14px 0',
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 14,
            padding: '12px 0',
        },
        [theme.breakpoints.down('400')]: {
            fontSize: 12,
            padding: '10px 0',
        }
    },
    itemSelected: {
        color: 'white',
        backgroundColor: '#344450'
    },
    container: {
        width: '85%',
        height: 'auto',
        minHeight: 300,
        marginBottom: '3%',
        backgroundColor: '#F2F3F2',
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        [theme.breakpoints.down('769')]: {
            width: '100%'
        }
    },
    eventContent: {
        display: 'flex',
        flexDirection: 'column',
        width: '85%',
        [theme.breakpoints.down('1100')]: {
            width: '95',
        },
        [theme.breakpoints.down('400')]: {
            width: '100%',
        },
        margin: '0 auto'
    },
    eventContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        [theme.breakpoints.down('600')]: {
            justifyContent: 'space-around'
        },
    },
    eventBox: {
        width: '100%',
        minHeight: 450,
        cursor: 'pointer',
        backgroundColor: '#FFFFFF',
        padding: 10,
        paddingBottom: 20,
        boxShadow: '0px 3px 3px rgb(177, 174, 174)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        alignSelf: 'center',
        alignContent: 'center'
    },
    styleEvent: {
        width: '31.5%',
        [theme.breakpoints.down('1100')]: {
            width: '45%',
        },
        [theme.breakpoints.down('600')]: {
            width: '90%',
        },
        minWidth: 240,
        marginBottom: 25,
    },
    eventDate: {
        color: '#344450',
        display: 'flex',
        flexDirection: 'row',
        alignSelf: 'center',
        fontSize: 16
    },
    eventImage: {
        height: 'auto',
        width: '100%',
        marginBottom: '5%'
    },
    newImage: {
        height: 'auto',
        width: '100%'
    },
    eventDetails: {
        height: 'auto',
        minHeight: 250,
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        [theme.breakpoints.down('769')]: {
            width: '100%',
        },
    },
    eventText: {
        textAlign: 'center',
        padding: '5%',
        width: '100%',
    },
    eventTitle: {
        lineHeight: '1.2em',
        fontSize: 20,
        color: '#344450',
        marginBottom: 15,
        fontWeight: 'bold',
        textAlign: 'center',
        [theme.breakpoints.down('769')]: {
            width: '95%',
            paddingTop: 0
        },
    },
    eventDescription: {
        lineHeight: '1.5em',
        textAlign: 'center',
        fontSize: 18,
        maxWidth: '100%',
        paddingTop: 0,
        color: '#344450',
        '& p': {
            margin: 0
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 16,
            width: '90%',
            paddingTop: 0
        },
    },
    interactionsSummary: {
        color: '#344450',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    interactionsCount: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0 5px',
        justifyContent: 'flex-end'
    },
    yellowLine: {
        height: 8,
        width: '80%',
        backgroundColor: '#F5B750',
        margin: '0 auto',
        marginBottom: '7%',
        boxShadow: 'inset 0px 3px 3px rgb(177, 174, 174)',
    },
    root: {
        '& .MuiInput-underline:after': {
            borderColor: '#F5B750',
            borderRadius: 0
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'transparent'
            },
            '&:hover fieldset': {
                borderColor: 'transparent'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#F5B750',
                borderRadius: 0
            },
            '&.Mui-focused .MuiInputAdornment-root .MuiSvgIcon-root': {
                color: '#F5B750'
            },
        },
        backgroundColor: '#FFFFFF',
        margin: 'auto',
        marginTop: 20,
        marginBottom: 20,
        [theme.breakpoints.down('769')]: {
            marginTop: 10,
            marginBottom: 10,
        },
        width: '100%',
        [theme.breakpoints.down('600')]: {
            width: '90%',
        }
    },
    multilineColor: {
        color: '#344450',
        fontSize: 18,
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 14,
            height: 30
        },
    },
    yellowLine: {
        height: 8,
        width: '80%',
        backgroundColor: '#F5B750',
        margin: '0 auto',
        boxShadow: 'inset 0px 3px 3px rgb(177, 174, 174)',
    }
}))

export default useStyles